/**
 * Preview feature constants.
 * Must match GraphQL PreviewFeature enum.
 */
export const PreviewFeature = {
    /** New Workspace 2.0 feature */
    NEW_WORKSPACE_20: 'NEW_WORKSPACE_20',
    /** Level of Specification Automation feature */
    LOS_AUTOMATION: 'LOS_AUTOMATION',
    /** Product Type Automation feature */
    PT_AUTOMATION: 'PT_AUTOMATION',
    /** OM Workspace - enables new workspace toggle for Office Master workspaces */
    OM_WORKSPACE: 'OM_WORKSPACE',
    /** OM Product Type Automation - controls PT deactivation UX in OM workspace */
    OM_PT_AUTOMATION: 'OM_PT_AUTOMATION',
} as const

/** Type for preview feature values */
export type PreviewFeature = typeof PreviewFeature[keyof typeof PreviewFeature]
